import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    accountinfo: {},
    maintenanceDialog: false,
  },
  getters: {
    getaccount: (state) => state.accountinfo,
    getMaintenanceDialogState: (state) => state.maintenanceDialog,
  },
  actions: {
    async getaccount({ commit }) {
      const url = `settings/getOrganizationProfile`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setaccountinfo", response.data.data); // Ensure the correct data structure
      }
    },
    uploadImage({ commit }, payload) {
      const url = `Chats/UploadImage`;
      return makeApiCallWithImages(url, "POST", payload).then((response) => {
        return response;
      });
    },
  },
  mutations: {
    setaccountinfo(state, payload) {
      state.accountinfo = payload; // Correctly assign payload
    },
    setMaintenanceDialogState(state, value) {
      state.maintenanceDialog = value;
    },
  },
};
